import React from "react"
import { ButtonGroup } from "@mui/material"
import Button from "@mui/material/Button"
import { flexBox } from "style/style_snippets"

const languageToggleStyle = {
  wrapper: {
    width: "100%",
    ...flexBox.row,
    justifyContent: "flex-end",
    alignItems: "center",
    marginBottom: 15,
  },
}
export const LANGUAGES = {
  EN: "EN",
  DE: "DE",
}

export const getContent = ({ language, content }) => {
  const languages = {
    [LANGUAGES.EN]: content[LANGUAGES.EN],
    [LANGUAGES.DE]: content[LANGUAGES.DE],
  }
  return languages[language]
}

const LanguageToggle = ({ currentLanguage, setCurrentLanguage, children }) => {
  return (
    <>
      <div css={languageToggleStyle.wrapper}>
        <ButtonGroup size="small" aria-label="select language">
          <Button
            onClick={() => setCurrentLanguage(LANGUAGES.EN)}
            color={currentLanguage === LANGUAGES.EN ? "primary": "inherit"}
          >
            EN
          </Button>
          <Button
            onClick={() => setCurrentLanguage(LANGUAGES.DE)}
            color={currentLanguage === LANGUAGES.DE ? "primary": "inherit"}
          >
            DE
          </Button>
        </ButtonGroup>
      </div>
      {children}
    </>
  )
}
export default LanguageToggle
